import Vue from 'vue'
import App from '@/App.vue'
import router from '@/router'
import index  from '@/store'
import '@/styles/theme.scss'
import titleMixin from '@/mixins/titleMixin'
import InfiniteLoading from 'vue-infinite-loading'
import VModal from 'vue-js-modal'
import '@/firebaseConfig'
import { auth } from 'firebase/app'

Vue.config.productionTip = false

//Register Title Mixin functionality
Vue.mixin(titleMixin)

//Register infinite loading plugin
Vue.use(InfiniteLoading, {
  props: {
    spinner: 'circles',
    /* default | spiral | circles | bubbles | waveDots */
    /* other props need to configure */
  },
  slots: {
    noMore: '', // you can pass a string value
    noResults: '', // you can pass a string value
  },
});

//Register vue-js-modal plugin
//Using this instead of Bootstrap modal to avoid importing Jquery and half of the Bootstrap JS
Vue.use(VModal)

//Add an auth state change observer so that routes adhere to changes in auth
let app: Vue;
auth().onAuthStateChanged(user => {
    if (!app) {
      app = new Vue({
        router,
        store: index,
        render: (h) => h(App),
      }).$mount('#app')
    }
  },
);
